import {
  ConversationType,
  ConversationTypeSelector
} from "PFApp/components/activity_form/form_selectors/conversation_type_selector";
import { FIELD_NAME_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useWatchIsNew } from "PFApp/hooks/activity_form/multi_roles_form/use_watch_is_new";
import { RoleFormKey } from "PFApp/types/activity_form/activity_form_schema";
import { InputFocusProps } from "PFComponents/table/interactive/use_cell_input_focus";
import { RefObject } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SidePanelCellFormSection } from "../side_panel_cell_form_section";

type ChatCellProps = {
  conversationType?: ConversationType;
  onChange: (conversationType: ConversationType) => void;
  roleFormKey: RoleFormKey;
  disabled?: boolean;
  error?: string;
  title?: string;
  inputFocusProps?: InputFocusProps;
  buttonRef?: RefObject<HTMLButtonElement>;
};

export const ChatCell = ({
  conversationType = ConversationType.Direct,
  onChange,
  roleFormKey,
  disabled,
  error,
  title,
  inputFocusProps,
  buttonRef
}: ChatCellProps) => {
  const { t: tSections } = useTranslation("activities", { keyPrefix: "form.sections" });
  const { t: tConversation } = useTranslation("activities", { keyPrefix: "form.sections.conversation" });
  const { t: tBlueprints } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });
  const roleName = useWatch({ name: `${roleFormKey}.${FIELD_NAME_KEY}` });
  const isNew = useWatchIsNew(roleFormKey);

  const handleConversationTypeChange = (id: ConversationType) => {
    onChange(id);
  };

  const displayText =
    conversationType === ConversationType.Group
      ? tConversation("groupConversation")
      : tConversation("oneToOnePrivate");

  return (
    <SidePanelCellFormSection
      label={displayText}
      sidePanelTitle={tSections("conversation.title")}
      disabled={disabled}
      error={error}
      editAriaLabel={tBlueprints("editConversationInRole", {
        roleName: roleName || tBlueprints("emptyRoleName")
      })}
      cellAriaLabel={title}
      inputFocusProps={inputFocusProps}
      buttonRef={buttonRef}
    >
      {isNew && (
        <ConversationTypeSelector
          conversationType={conversationType}
          onConversationTypeChange={handleConversationTypeChange}
          isDisabled={disabled}
        />
      )}
    </SidePanelCellFormSection>
  );
};
